import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../utils/errors';

const initialState = {
  sections: {},
  defaultRoutes: {},
  depotStats: {},
  loading: false,
  error: null,
};

export const successSectionsFetch = createAsyncThunk(
  'sections/fetchSections',
  async (data, { rejectWithValue }) => {
    try {
      const sections = data.section.reduce((acc, item) => {
        acc[item.sectionCode] = item;
        return acc;
      }, {});

      const defaultRoutes = data.defaultRoutes.reduce((acc, route) => {
        acc[route.routeId] = route;
        return acc;
      }, {});

      return {
        sections,
        defaultRoutes,
        depotStats: data.depotStats,
      };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(successSectionsFetch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(successSectionsFetch.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload.sections;
        state.defaultRoutes = action.payload.defaultRoutes;
        state.depotStats = action.payload.depotStats;
      })
      .addCase(successSectionsFetch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default sectionsSlice.reducer;
